import axios from 'axios';
import { attachAuthInterceptor } from './authInterceptor';
import { API_BASE_URL } from '../utils/constants';
import { getAuthToken } from '../utils/storage';
import { extractApiError } from '../utils/apiError';
import { applyWarehouseFilter, warehouseParamsSerializer } from '../utils/warehouseParams';

const workloadAPI = axios.create({
    baseURL: `${API_BASE_URL}/api/v1`,
    headers: { 'Content-Type': 'application/json' },
    paramsSerializer: warehouseParamsSerializer,
});

// Session-expiry handling (401 -> clear + redirect), consistent with feature services.
attachAuthInterceptor(workloadAPI);

workloadAPI.interceptors.request.use(
    (config) => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return applyWarehouseFilter(config);
    },
    (error) => Promise.reject(error)
);

const supervisorWorkloadService = {
    async getList(params = {}) {
        try {
            const response = await workloadAPI.get('/supervisor-workload', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },

    async getDetail(supervisorId) {
        try {
            const response = await workloadAPI.get(`/supervisor-workload/${supervisorId}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: extractApiError(error) };
        }
    },
};

export default supervisorWorkloadService;
